import { Component, Inject, OnInit } from '@angular/core';
import { DashboardInput } from '../../power-bi/model/power-bi.model';
import { APP_CONFIG } from '../../common/constants';
import { AppConfig } from '../../model/app-config.model';

@Component({
  standalone: false,
  selector: 'app-qos-view',
  templateUrl: './qos-view.component.html',
  styleUrls: ['./qos-view.component.css']
})
export class QosViewComponent implements OnInit {

  powerBIConfig: DashboardInput;

  constructor(@Inject(APP_CONFIG) appConfig: AppConfig) {
    this.powerBIConfig = appConfig.qosPowerBIDashboard;
  }

  ngOnInit() {
  }

}

